export default "__VITE_ASSET__B70JBllR__"